export type PhoneActionPayload = {
  phone: string | number | null | undefined
  label?: string
  noteId?: string | number | null
}

const normalizePhone = (value: string | number | null | undefined) => {
  const raw = String(value || '').trim()
  if (!raw) return ''

  let digits = raw.replace(/\D/g, '')
  if (!digits) return ''

  if (digits.startsWith('00')) digits = digits.slice(2)
  if (digits.startsWith('0')) digits = `90${digits.slice(1)}`
  if (digits.length === 10) digits = `90${digits}`

  return digits
}

export const usePhoneActions = () => {
  const menuOpen = useState<boolean>('phone-actions:menu-open', () => false)
  const historyOpen = useState<boolean>('phone-actions:history-open', () => false)
  const phone = useState<string>('phone-actions:phone', () => '')
  const label = useState<string>('phone-actions:label', () => '')
  const noteId = useState<string>('phone-actions:note-id', () => '')

  const setPhone = (payload: PhoneActionPayload) => {
    phone.value = normalizePhone(payload.phone)
    label.value = String(payload.label || payload.phone || '').trim()
    noteId.value = String(payload.noteId || '').trim()
  }

  const openMenu = (payload: PhoneActionPayload) => {
    setPhone(payload)
    if (!phone.value) return
    menuOpen.value = true
  }

  const closeMenu = () => {
    menuOpen.value = false
  }

  const openHistory = () => {
    menuOpen.value = false
    historyOpen.value = true
  }

  const closeHistory = () => {
    historyOpen.value = false
  }

  const closeAll = () => {
    menuOpen.value = false
    historyOpen.value = false
  }

  const historyUrl = computed(() => {
    if (!phone.value) return ''
    const id = noteId.value || phone.value
    return `/admin/user/${id}?mobile=${phone.value}`
  })

  return {
    menuOpen,
    historyOpen,
    phone,
    label,
    noteId,
    historyUrl,
    openMenu,
    closeMenu,
    openHistory,
    closeHistory,
    closeAll,
  }
}
